import React from "react";
import styles from "./CMProvider.module.scss"
import Overlay from "../Overlay/Overlay";
import styled from "styled-components";
import StyledContainer from "../StyledContainer";
import { ReactComponent as CMButton2 } from './cm-button.svg';

export const CustomCMButton = styled(CMButton2)`
    position: absolute;
    left: 5%;
    top: 0;
    cursor: pointer;
    z-index: 99;
    & .st0 {
        fill: ${({ color }) => color || "#68A2BC"};
        stroke: "#10141C"
    }
    &:hover .st0 {
        fill ${({ hovercolor }) => hovercolor || "blue"};
    }
    &:hover .st1 {
        fill "#000000"};
    }
`;

const CM = (props) => {
    const { children, CMButton, CMOpener, content } = props;
    const [overlay, setOverlay] = React.useState(false);

    const handleOpen = () => {
        setOverlay(true);
    }

    const handleCloseOverlay = () => {
        setOverlay(false);
    }

    return <>
        <div onClick={handleOpen}>
            <CustomCMButton color="#68A2BC" hovercolor="rgb(43, 57, 93)" />
        </div>
        {children}
        {overlay && <Overlay onClose={handleCloseOverlay}>

            <StyledContainer style={{ height: `50%`, width: `80%`, display: `flex`, flexDirection: `column` }}>
                <div>
                    <div dangerouslySetInnerHTML={{ __html: CMOpener }}></div>
                    <ul dangerouslySetInnerHTML={{ __html: content.join('') }}>
                    </ul>
                </div>
            </StyledContainer>

        </Overlay>}
    </>
}

export default CM;
var Btn = styled.div`
    position: absolute;
    left: 5%;
    padding: .45rem;
    z-index: 100;
    color: #78A1BB;
    background: #232a3b8c;
    border-bottom-right-radius: 7px;
    border-bottom-left-radius: 7px;
    cursor: pointer;
    font-size: .6rem;
`
const getCollapsibleMenu = (props) => {
    try {
        return props.contentData.modules[0]
            .lessons.find(l => l['name'] === "Menu")
            .chapters[0]
            .segments.find(s => s['type'] === "collapsiblemenu");
    } catch (error) {
        return undefined;
    }
}

const getConceptual = (lessons, currentLocation) => {
    var conceptual;
    lessons.forEach(l => {
        l.chapters.forEach(c => {
            if (c.location.module === currentLocation.module &&
                c.location.lesson === currentLocation.lesson &&
                c.location.chapter === currentLocation.chapter &&
                c.location.segment === currentLocation.segment &&
                c.conceptual)
                conceptual = c.conceptual
        });
    });
    return conceptual;
}

const getActiveCMs = (conceptualObj) => {
    var CMS = [];

    for (const key in conceptualObj)
        if (Object.hasOwnProperty.call(conceptualObj, key)) {
            const element = conceptualObj[key];
            if (element === true) CMS.push(key.toUpperCase())
        }
    return CMS;
}

export const CMHOC = (props, components) => {
    var menu = getCollapsibleMenu(props);

    if (!menu || menu.config === undefined) return components;

    var lessons = menu.lessons;
    var currentLocation = props.currentLocation;

    var conceptual = getConceptual(lessons, currentLocation);
    if (conceptual === undefined) return components;

    var cmList = getActiveCMs(conceptual);

    if (conceptual && cmList.length > 0)
        return <CM
            header={menu.config.header}
            backgroundImage={menu.config.backgroundImage}
            headerBackground={menu.config.headerBackground}
            CMButton={menu.config.CMButton}
            CMOpener={menu.config.CMOpener}
            content={cmList.map(cm => {
                return menu.config[`${cm}Content`]
            })}
        >{components}</CM>;
    else return components;
}